<div id="standard-modal" role="dialog" aria-labelledby="modalContactList">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="modalContactList">
          Visualizar Localização
        </h4>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-hidden="true"
          (click)="close()"
        ></button>
      </div>
      <div class="modal-body custom-scroll-bar" style="overflow: hidden;">
        <div class="row">
          <div class="col-12 input-trend-search">
            <google-map
              height="400px"
              width="100%"
              [center]="center"
              [zoom]="zoom"
              (mapMousemove)="move($event)"
            >
              @for (position of markerPositions; track position) {
              <map-marker [position]="position" [options]="markerOptions" />
              }
            </google-map>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light"
            data-bs-dismiss="modal"
            (click)="close()"
          >
            Fechar
          </button>
          <button type="button" class="btn btn-outline-primary" (click)="copyContent()">
            Copiar URL de Localização
          </button>
          <button type="button" class="btn btn-primary" (click)="openInNewTab()">
            Abrir no Google Maps
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
